var exports = {
  "aP": "OperatorPassConsentBox.module__box___TlFZS0",
  "EL": "OperatorPassConsentBox.module__boxError___TlFZS0",
  "kv": "OperatorPassConsentBox.module__checkbox___TlFZS0",
  "Pf": "OperatorPassConsentBox.module__label___TlFZS0",
  "z3": "OperatorPassConsentBox.module__error___TlFZS0",
  "h5": "OperatorPassConsentBox.module__status___TlFZS0",
};

module.exports = exports;
